import { render } from "./Vue3IntlInput.vue?vue&type=template&id=600fb4ee"
import script from "./Vue3IntlInput.vue?vue&type=script&lang=js"
export * from "./Vue3IntlInput.vue?vue&type=script&lang=js"

import "./Vue3IntlInput.vue?vue&type=style&index=0&id=600fb4ee&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__